import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-preis-anpassung-dialog',
    templateUrl: './preis-anpassung-dialog.component.html',
    styleUrls: ['./preis-anpassung-dialog.component.scss'],
})
export class PreisAnpassungDialogComponent implements OnInit {
    public einzelpreisCtrl: FormControl = new FormControl(undefined, [Validators.required, Validators.min(0.01)]);

    isLoading = false;

    constructor(
        public dialogRef: MatDialogRef<PreisAnpassungDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PreisAnpassungInput,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        if (this.data.einzelpreis) {
            this.einzelpreisCtrl.setValue(this.data.einzelpreis);
        }
    }

    public cancel(): void {
        const result: PreisAnpassungResult = new PreisAnpassungResult();
        result.confirm = false;
        this.dialogRef.close(result);
    }

    public submit(): void {
        this.isLoading = true;
        const result: PreisAnpassungResult = new PreisAnpassungResult();
        this.data.einzelpreis = this.einzelpreisCtrl.value;
        this.api.updateEntity(this.apiBaseUrl + 'befund/update_einzelpreis.php', this.data).subscribe({
            next: response => {
                this.messageService.infoMessage('Einzelpreisänderung wurde erfolgreich gespeichert!');
                result.confirm = true;
                result.preisanpassung = response;
                this.isLoading = false;
                this.dialogRef.close(result);
            },
            error: err => {
                result.confirm = false;
                this.isLoading = false;
                this.messageService.errorMessage('Einzelpreisänderung konnte nicht gespeichert werden!', err);
                this.dialogRef.close(result);
            },
        });
    }

    public disabled(): boolean {
        return this.einzelpreisCtrl.invalid;
    }
}

export class PreisAnpassungInput {
    ba_id: number;
    einzelpreis: number;
    artikel: string;
}

export class PreisAnpassungResult {
    preisanpassung: PreisAnpassungInput;
    confirm: boolean;
}
